import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import Link from "flarum/common/components/Link";
export default class XgayHeaderLogo extends Component {
  view() {
    const isIndex = app.current.get("routeName") === "index";
    return m("div", {
      className: "XgayHeaderLogo"
    }, isIndex ? m("h1", null, this.linkTag()) : m("div", null, this.linkTag()));
  }
  linkTag() {
    return m("div", null, m(Link, {
      href: app.routes.index.path,
      title: "XGAY24 - SPA - MASSAGE GAY - SAUNA - CH\u0102M S\xD3C S\u1EE8C KH\u1ECEE GI\u1EDAI GAY 24/7"
    }, m("img", {
      src: app.forum.attribute('logoUrl'),
      alt: app.forum.attribute('title')
    })), m("p", null, "SPA - MASSAGE GAY - SAUNA - CH\u0102M S\xD3C S\u1EE8C KH\u1ECEE GI\u1EDAI GAY 24/7"));
  }
}
flarum.reg.add('xgay-core', 'forum/components/XgayHeaderLogo', XgayHeaderLogo);